export const highlightSearchTerm = (text, searchTerm) => {
  if (!searchTerm || !text || searchTerm.length < 3) return text;

  const regex = new RegExp(`(${searchTerm})`, 'gi');
  const parts = text.toString().split(regex);
  return parts.map((part, index) =>
    regex.test(part) ? (
      <span key={index} style={{ backgroundColor: '#E3F2FD', color: '#1565C0', padding: '0 2px', borderRadius: '2px' }}>{part}</span>
    ) : (
      part
    )
  );
};

const parseApiDate = (dateValue) => {
  if (!dateValue) return null;

  if (dateValue instanceof Date) {
    return Number.isNaN(dateValue.getTime()) ? null : dateValue;
  }

  if (typeof dateValue === 'string') {
    const hasTimezone = /(?:z|[+-]\d{2}:?\d{2})$/i.test(dateValue);
    const isIsoDateTime = /^\d{4}-\d{2}-\d{2}T/.test(dateValue);
    const normalizedValue = isIsoDateTime && !hasTimezone ? `${dateValue}Z` : dateValue;
    const parsedDate = new Date(normalizedValue);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  }

  const parsedDate = new Date(dateValue);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const formatRelativeTime = (dateString) => {
  const date = parseApiDate(dateString);
  if (!date) return '';

  const now = new Date();
  const diffMs = Math.max(0, now - date);
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffSeconds < 60) {
    return `${diffSeconds} second${diffSeconds !== 1 ? 's' : ''} ago`;
  }
  if (diffMinutes < 60) {
    return `${diffMinutes} minute${diffMinutes !== 1 ? 's' : ''} ago`;
  }
  if (diffHours < 24) {
    return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
  }
  return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
};

export const mapRoleIdToUserType = (roleId) => {
  if (!roleId) return null;

  switch (Number(roleId)) {
    case 2: return 'admin';
    case 3: return 'department';
    case 4: return 'caregiver';
    case 5: return 'security';
    case 6: return 'housekeeping';
    case 7: return 'f&b';
    default: return null;
  }
};
